import { create } from 'zustand';

type TaskTimeoutModalState = {
  isOpen: boolean;
  taskId: string | null;
  open: (taskId: string) => void;
  close: () => void;
};

export const useTaskTimeoutModalStore = create<TaskTimeoutModalState>(
  (set) => ({
    isOpen: false,
    taskId: null,

    open: (taskId) => set({ isOpen: true, taskId }),

    close: () => set({ isOpen: false, taskId: null }),
  })
);
